import { IConfigurableTable } from "libraries/interfaces/i-configurable-table";

export const CONFIG_DEFAULT: IConfigurableTable ={
    "isVisibleHeader": true,
    "columnArray": [
        {
            "key": "COL_1",
            "defaultLabel": "Dossier",
            "fieldKeyArray": [
                "CODE",
                "SYSTEM",
                "BOOKING_STATUS"
            ],
            "isDisplayed": true
        },
        {
            "key": "COL_1",
            "defaultLabel": "Date de création",
            "fieldKeyArray": [
                "CREATION_DATE"
            ],
            "isDisplayed": true
        },
        {
            "key": "COL_1",
            "defaultLabel": "Dates de début et de fin",
            "fieldKeyArray": [
                "BEGIN_DATE",
                "END_DATE"
            ],
            "isDisplayed": true
        },
        {
            "key": "COL_1",
            "defaultLabel": "Voyageur",
            "fieldKeyArray": [
                "TRAVELLER"
            ],
            "isDisplayed": true
        },
        {
            "key": "COL_1",
            "defaultLabel": "Flux de création",
            "fieldKeyArray": [
                "WORKFLOW_STATUS",
                "WORKFLOW_MESSAGE"
            ],
            "isDisplayed": true
        }
    ]
};
